import { c as _c } from "react/compiler-runtime";
import { motion } from "motion/react";
import type { SystemMessage as SystemMessageData } from "@/types/agent/message";
interface SystemMessageProps {
  message: SystemMessageData;
}

/**
 * Centered status note in the chat (e.g. "Neue Konversation gestartet").
 * A dark, transparent pill with small white text – not tied to a sender.
 *
 * `rounded-2xl` rather than `rounded-full` so multi-line notes keep sane corners.
 * On a single-line pill the browser clamps the radius to half the height, which
 * is exactly what `rounded-full` produced — those rows are unchanged.
 */
export const SystemMessage: React.FC<SystemMessageProps> = t0 => {
  const $ = _c(5);
  const {
    message
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      y: 10
    };
    t2 = {
      opacity: 1,
      y: 0
    };
    t3 = {
      duration: 0.3,
      ease: "easeOut"
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== message.content) {
    t4 = <motion.div className="rounded-2xl bg-black/40 px-4 py-1.5 text-xs text-white/90 backdrop-blur-xl" initial={t1} animate={t2} transition={t3}>{message.content}</motion.div>;
    $[3] = message.content;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};